import { Card } from 'antd';
import styled from 'styled-components';


const CardStyle = styled(Card)`
  &&& {
    border-radius: 20px;
    box-shadow: 0px 3px 6px #e8e8e8;
    transition: 0.2s;
    &:hover {
      box-shadow: 0px 12px 24px #e8e8e8;
      transition: 0.2s;
    }
    .ant-card-body {
      padding: 20px;
    }
  }
`;

export default CardStyle;
